type RuntimeFlagLike = {
  name: string;
  value: unknown;
  source: "default" | "global" | "brand";
};

export const getAutopilotRuntimeFlag = (flags: readonly RuntimeFlagLike[] | undefined) => {
  const flag = flags?.find((item) => item.name === "campaign_autopilot_enabled");

  return {
    enabled: typeof flag?.value === "boolean" ? flag.value : true,
    source: flag?.source ?? "default",
  };
};

export const getAutopilotSourceLabel = (source: "default" | "global" | "brand") =>
  source === "brand" ? "Brand override" : source === "global" ? "Global default" : "Default";
